import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ValidatorsExtend } from 'src/app/shared/validators/validators-extend';
@Component({
  selector: 'app-control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss']
})
export class ControlMessagesComponent {

  @Input() control: AbstractControl<any, any> | null = null;
  constructor() { }

  get errorMessage() {
    for (const propertyName in this.control?.errors) {
      if (this.control?.errors.hasOwnProperty(propertyName) && this.control.touched) {
        return ValidatorsExtend.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }
    return null;
  }

}
